import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString } from 'services/router/actions';

// Components
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';

// Selectors
import { makeSelectValuesTimesheetEntryValue } from 'services/timesheetTimesheetEntriesForm/selectors';

interface Props {
    updateQueryString: Function;
    timesheetId: number;
    workTypeCompositeKey: string;
    entityCompositeKey: string;
    date: string;
    startTime?: ?string;
    endTime?: ?string;
    rate?: ?number;
    units?: ?number;
    paidBreakMinutes?: ?number;
    unpaidBreakMinutes?: ?number;
    personId: number;
}

export class TimesheetEntryDuplicateDropdownItem extends React.PureComponent<Props> {
    handleClick = (event: SyntheticInputEvent<EventTarget>) => {
        const {
            timesheetId,
            workTypeCompositeKey,
            entityCompositeKey,
            date,
            startTime,
            endTime,
            rate,
            units,
            paidBreakMinutes,
            unpaidBreakMinutes,
            personId
        } = this.props;

        this.props.updateQueryString({
            timesheetEntryModal: true,
            selectedTimesheetEntry: undefined,
            defaultValues: {
                timesheetId,
                workTypeCompositeKey,
                entityCompositeKey,
                startDate: date,
                endDate: date,
                startTime,
                endTime,
                rate,
                units,
                paidBreakMinutes,
                unpaidBreakMinutes,
                personIds: [personId]
            }
        });
    };

    render() {
        return (
            <CurrentSeasonInProgressGate>
                <Dropdown.Item text="Duplicate" onClick={this.handleClick} />
            </CurrentSeasonInProgressGate>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    timesheetId: makeSelectValuesTimesheetEntryValue('timesheetId'),
    workTypeCompositeKey: makeSelectValuesTimesheetEntryValue(
        'workTypeCompositeKey'
    ),
    entityCompositeKey: makeSelectValuesTimesheetEntryValue(
        'entityCompositeKey'
    ),
    date: makeSelectValuesTimesheetEntryValue('date'),
    startTime: makeSelectValuesTimesheetEntryValue('startTime'),
    endTime: makeSelectValuesTimesheetEntryValue('endTime'),
    rate: makeSelectValuesTimesheetEntryValue('rate'),
    units: makeSelectValuesTimesheetEntryValue('units'),
    paidBreakMinutes: makeSelectValuesTimesheetEntryValue('paidBreakMinutes'),
    unpaidBreakMinutes: makeSelectValuesTimesheetEntryValue(
        'unpaidBreakMinutes'
    ),
    personId: makeSelectValuesTimesheetEntryValue('personId')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(TimesheetEntryDuplicateDropdownItem);
